module.exports = __webpack_public_path__ + "static/eis6-5f8b1861e6d3427995f19360beb207f3.jpg";